import type { CommissionStatus, Sale } from "./schema";

// ── Règle unique « commission en avance » (source de vérité du CRM) ──────────
//
// Une commission est encaissée « en avance » quand elle est marquée *encaissée*
// (« € Comm. encaissée » → statut commission = payé) ALORS QUE le délai de
// rétractation de 14 j n'est pas encore écoulé. Tant qu'on est dans cette
// fenêtre, le client peut se rétracter : l'argent déjà touché est provisoire et
// peut devoir être rendu (clawback). Dès que le délai passe, c'est définitivement
// acquis et le marqueur disparaît de lui-même.
//
// NB : c'est bien l'encaissement de la COMMISSION qui compte (pas juste le fait
// d'avoir marqué la vente effectuée). Marquer une vente effectuée sans encaisser
// la commission n'est PAS une avance.
//
// `todayISO` est au format yyyy-mm-dd. La rétractation inclut son jour de fin
// (comparaison `<=`), cohérent avec effectiveCommissionStatus.

export function isCommissionInAdvance(
  effectiveCommissionStatus: CommissionStatus,
  retractationEndsAt: Sale["retractationEndsAt"],
  todayISO: string,
): boolean {
  return effectiveCommissionStatus === "paye" && todayISO <= retractationEndsAt;
}

export function isSaleInAdvance(
  effectiveCommissionStatuses: CommissionStatus[],
  retractationEndsAt: Sale["retractationEndsAt"],
  todayISO: string,
): boolean {
  return (
    todayISO <= retractationEndsAt &&
    effectiveCommissionStatuses.some((s) => s === "paye")
  );
}
